/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { batchActions } from 'redux-batched-actions';
// material
import { displaySuccessMessage, displayErrorMessage, exportcsv } from '@insticator/insticator-ui';
// utils
import { asyncGetStatisticsTableData, asyncExportStatisticsData } from 'utils/api/commenting';
import { transpileCommentingStatisticsData } from 'utils/transpilers/datavisualization';

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const FETCHING_COMMENTING_STATISTICS = 'FETCHING_COMMENTING_STATISTICS';
export const RECEIVE_COMMENTING_STATISTICS = 'RECEIVE_COMMENTING_STATISTICS';
export const EXPORTING_COMMENTING_STATISTICS = 'EXPORTING_COMMENTING_STATISTICS';
export const EXPORT_COMMENTING_STATISTICS = 'EXPORT_COMMENTING_STATISTICS';

const fetchingCommentingStatistics = status => ({
    type: FETCHING_COMMENTING_STATISTICS,
    status
});

const receiveCommentingStatistics = (data, hasMoreData) => ({
    type: RECEIVE_COMMENTING_STATISTICS,
    data,
    hasMoreData
});

const exportingCommentingStatistics = status => ({
    type: EXPORTING_COMMENTING_STATISTICS,
    status
});

const exportCommentingStatistics = () => ({
    type: EXPORT_COMMENTING_STATISTICS
});

const receiveCommentingStatisticsSuccess = (data, hasMoreData) => batchActions([
    fetchingCommentingStatistics(false),
    receiveCommentingStatistics(data, hasMoreData)
]);

const receiveCommentingStatisticsFail = () => batchActions([
    fetchingCommentingStatistics(false),
    displayErrorMessage('There was an issue fetching the statistics')
]);

const exportCommentingStatisticsSuccess = () => batchActions([
    exportingCommentingStatistics(false),
    exportCommentingStatistics()
]);

const exportCommentingStatisticsFail = () => batchActions([
    exportingCommentingStatistics(false),
    displayErrorMessage('There was an issue exporting the statistics')
]);

export const exportStatisticsData = (commentingUnitUUID, interval) => dispatch => {
    dispatch(exportingCommentingStatistics(true));
    asyncExportStatisticsData(commentingUnitUUID, interval)
        .then(response => {
            exportcsv(response.data, `CommentingStatistics.csv`, null);
            dispatch(exportCommentingStatisticsSuccess());
        }).catch(err => {
            if(err.response){
                if (err.response.status === 404) {
                    return dispatch(displayErrorMessage('There is no statistics data to export.'))
                }
            }
            dispatch(exportCommentingStatisticsFail())
        })
}

export const loadCommentingStatisticsTableData = (commentingUnitUUID, interval, skip, existingData) => dispatch => {
    dispatch(fetchingCommentingStatistics(true));
    asyncGetStatisticsTableData(commentingUnitUUID, interval, skip)
        .then(response => {
            const statsData = !existingData ? transpileCommentingStatisticsData(response.data) : existingData.concat(transpileCommentingStatisticsData(response.data))
            dispatch(receiveCommentingStatisticsSuccess(statsData, response.data.hasMoreData))
        })
        .catch(err => dispatch(receiveCommentingStatisticsFail()))
}
